<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="产品类型" prop="categoryId" required>
        <el-select
            v-model="form.categoryId"
            filterable
            reserve-keyword
            placeholder="搜素类型"
        >
          <el-option
              v-for="option in productCateOption"
              :key="option.key"
              :label="option.value"
              :value="option.key"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="输入名称(后台显示)" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title" placeholder="输入标题(前端显示)" :clearable="true"></el-input>
      </el-form-item>
      <el-form-item label="推介指数"  prop="completionDays">
        <el-rate
            style="margin-top: 10px"
            v-model="form.starLevel"
            >
        </el-rate>
      </el-form-item>
      <el-form-item label="图标" prop="icon">
        <uploadImg
            v-model="form.icon"
            :imgSize="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>

      <el-form-item label="封面" prop="icon">
        <uploadImg
            v-model="form.cover"
            :imgSize="1"
            :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>

      <el-form-item label="介绍视频">
        <upload-video
            v-model="form.explanatoryVideo"
        ></upload-video>
      </el-form-item>

      <el-form-item label="完成周期(天)" prop="completionDays">
        <el-input-number v-model="form.completionDays" :step="1" step-strictly></el-input-number>
      </el-form-item>

      <el-form-item label="价格(元)">
        <el-input-number v-model="form.price" :step="0.01" step-strictly></el-input-number>
      </el-form-item>

      <el-form-item label="状态">
        <el-switch
            v-model="form.status"
            :active-value="1"
            :inactive-value="0"
            active-text="上架"
            inactive-text="下架">
        </el-switch>
      </el-form-item>

      <el-form-item label="合作商家">
        <el-switch
            v-model="form.joinHands"
            :active-value="1"
            :inactive-value="0"
            active-text="是"
            inactive-text="否">
        </el-switch>
      </el-form-item>
      <el-form-item label="产品规格">
<!--         规格选项管理   -->
        <div>
          <el-button
              size="small"
              type="primary"
              @click="addSpec"
          >
            添加规格
          </el-button>
          <div class="spec-item" v-for="(item, index) in form.specList">
            <el-form label-width="80px" :rules="specItemRules">
              <el-form-item label="规格">
                <el-select
                    size="small"
                    v-model="item.id"
                    filterable
                    reserve-keyword
                    placeholder="搜素规格"
                    onchange="chooseSpecChange"
                >
                  <el-option
                      v-for="option in specOptions"
                      :key="option.key"
                      :label="option.value"
                      :value="option.key"
                      :disabled="isSelectSpec(option.key)"
                  />
                </el-select>
              </el-form-item>
              <el-form-item label="可选数量">
                  <el-input-number size="small" v-model="item.limit" :step="1" step-strictly></el-input-number>
              </el-form-item>
              <el-form-item label="规格值" prop="valuesIdList">
                <select-values :spec-id="item.id" :value="item.valuesIdList" @update:value="item.valuesIdList = $event"></select-values>
              </el-form-item>
            </el-form>
<!--           右上角删除 -->
            <div class="spec-item-bottom-right"   @click="delSpec(index)">
              <span
                style="color: #FFFFFF;font-size: 14px;"
              >x</span>
            </div>

          </div>
        </div>
      </el-form-item>
      <el-collapse >
        <el-collapse-item >
          <template slot="title" >
            工作内容<i class="header-icon el-icon-info"></i>
          </template>
          <el-form-item >
            <div style="margin-bottom: 20px;">
              <el-button
                  size="small"
                  @click="addTab(editableTabsValue)"
              >
                添加内容
              </el-button>
            </div>
            <el-tabs v-model="editableTabsValue"  closable @tab-remove="removeTab" tab-position="left" style="min-height: 400px;">
              <el-tab-pane
                  v-for="(item, index) in form.contentList"
                  :key="item.id"
                  :label="item.name"
                  :name="item.id"
              >
                <el-form label-width="100px" :rules="itemRules" size="mini" >
                  <el-form-item>
                    <el-form-item label="名称">
                      <el-input v-model="item.name" :ref="'input_' + item.name" @change="(name)=>{nameChange(name,'input_' + item.name)}" placeholder="输入名称(后台显示)" :clearable="true"></el-input>
                    </el-form-item>
                    <el-form-item label="标题">
                      <el-input v-model="item.title" placeholder="输入标题(前端显示)" :clearable="true"></el-input>
                    </el-form-item>
                    <el-form-item label="图标" prop="icon">
                      <uploadImg
                          v-model="item.icon"
                          :imgSize="1"
                          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
                      ></uploadImg>
                    </el-form-item>
                    <el-form-item label="完成周期(天)"  prop="completionDays">
                      <el-input-number v-model="item.completionDays" :step="1" step-strictly></el-input-number>
                    </el-form-item>

                    <el-form-item label="任务模板"  prop="completionDays">
                      <el-select
                          v-model="item.templateId"
                          filterable
                          reserve-keyword
                          placeholder="搜素模板"
                      >
                        <el-option
                            v-for="option in themeTplOption"
                            :key="option.key"
                            :label="option.value"
                            :value="option.key"
                        />
                      </el-select>
                      <el-link style="margin-left: 10px" @click="$router.push('/demo/punchTheClockTpl/addToCard')" type="primary">新建模板</el-link>
                    </el-form-item>
                    <el-form-item label="内容介绍">
                      <div class="ql-editor" >
                        <quill-editor
                            ref="introductionQuillEditor"
                            v-model="item.introduction"
                            :options="editorOption"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                        />
                        <div class="simulator infinite-list-wrapper" style="overflow:auto" >
                          <div style="word-wrap: break-word; word-break: normal; " v-html="item.introduction">

                          </div>
                        </div>
                      </div>
                    </el-form-item>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item>
          <template slot="title">
            执行样例<i class="header-icon el-icon-info"></i>
          </template>
          <el-form-item >
            <div class="ql-editor">
              <quill-editor
                  ref="sampleCaseQuillEditor"
                  v-model="form.sampleCase"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
              />
              <div class="simulator infinite-list-wrapper" style="overflow:auto" >
                <div style="word-wrap: break-word; word-break: normal; " v-html="form.sampleCase">

                </div>
              </div>
            </div>
          </el-form-item>
        </el-collapse-item>
        <el-collapse-item >
          <template slot="title">
            策略依据<i class="header-icon el-icon-info"></i>
          </template>
          <el-form-item >
            <div class="ql-editor">
              <quill-editor
                  ref="descriptionQuillEditor"
                  v-model="form.description"
                  :options="editorOption"
                  @blur="onEditorBlur($event)"
                  @focus="onEditorFocus($event)"
                  @ready="onEditorReady($event)"
              />
              <div class="simulator infinite-list-wrapper" style="overflow:auto" >
                <div style="word-wrap: break-word; word-break: normal; " v-html="form.description">

                </div>
              </div>
            </div>
          </el-form-item>
        </el-collapse-item>

      </el-collapse>
    </el-form>
    <div class="footer">
      <el-button @click="$router.back()">取 消</el-button>
      <el-button type="success" @click="confirm('form')">确定</el-button>
    </div>
  </d2-container>
</template>
<script>
import {
  addProduct,
  getProductCateOption,
  getProductInfo,
  getProductSpecOption,
  updateProduct
} from '@/api/merchant/service/product'
import uploadImg from '@/components/uploadImage/index.vue'
import uploadVideo from '@/components/uploadVideo'

/**
 * 富文本工具
 */
import { Quill, quillEditor } from 'vue-quill-editor'
import { initEditor, initTitle, option } from '@/utils/editor'
import { getClockInTplOptions } from '@/api/demo/punchInActivityTpl'
import selectValues from '@/components/spec/selectValues.vue'

initEditor(Quill)

export default {
  name: 'editServiceProduct',
  components: {
    uploadImg,
    quillEditor,
    uploadVideo,
    selectValues
  },
  data () {
    return {
      newTabInx: 0,
      editableTabsValue: '2',
      productCateOption: [],
      themeTplOption: [],
      specOptions: [],
      id: '', // id
      form: {
        icon: '', // 图标
        cover: '', // 封面
        name: '', // 活动名称
        status: 0, // 状态
        completionDays: 1,
        price: 0.00,
        contentList: [],
        specList: []
      },
      replyOptionLoading: false,
      editorOption: option,
      rules: {
        categoryId: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        icon: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur'
          }
        ],
        completionDays: [
          {
            required: true,
            message: '请填写周期',
            trigger: 'blur'
          }
        ]
      },
      itemRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        title: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'blur'
          }
        ],
        icon: [
          {
            required: true,
            message: '请上传封面',
            trigger: 'blur'
          }
        ],
        completionDays: [
          {
            required: true,
            message: '请填写周期',
            trigger: 'blur'
          }
        ]
      },
      specItemRules: {
        valuesIdList: [
          {
            required: true,
            type: 'array',
            min: 1,
            message: '请选择规格值',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSpecOptions()
  },
  methods: {
    getSpecOptions () {
      let that = this
      getProductSpecOption().then(res => {
        that.specOptions = res
      })
    },
    nameChange (name, refName) {
      this.editableTabsValue = name
    },
    getThemeTpl () {
      let that = this
      getClockInTplOptions({}).then(res => {
        that.themeTplOption = res
      })
    },
    chooseSpecChange (value) {
    },
    addSpec () {
      if (!this.form.specList) {
        this.form.specList = []
      }
      let unSelectSpec = this.getUnSelectSpec()
      if (unSelectSpec.length === 0) {
        this.$message.error('没有可选规格了')
        return
      }
      this.form.specList.push({
        id: unSelectSpec[0].key,
        valuesIdList: [],
        limit: 1
      })
      this.$forceUpdate()
    },
    delSpec (index) {
      this.form.specList.splice(index, 1)
    },
    // 查询未选择的规格
    getUnSelectSpec () {
      let that = this
      let selectIds = this.form.specList.map(item => item.id)
      return this.specOptions.filter(item => !selectIds.includes(item.key))
    },
    // 查询规格是否已经选择
    isSelectSpec (id) {
      let selectIds = this.form.specList.map(item => item.id)
      return selectIds.includes(id)
    },
    addTab (targetName) {
      this.newTabInx++
      let tabs = this.form.contentList
      let newTabName = '新建内容' + this.newTabInx + '[请修改]'
      tabs.push({
        id: this.newTabInx,
        name: newTabName,
        completionDays: 0
      })
      this.editableTabsValue = this.newTabInx
    },
    removeTab (targetName) {
      this.$confirm('确认删除内容吗', '确认操作', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.confirmRemoveTab(targetName)
        })
        .catch(() => {
        })
    },
    confirmRemoveTab (targetName) {
      let tabs = this.form.contentList
      let activeName = this.editableTabsValue
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.id === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1]
            if (nextTab) {
              activeName = nextTab.id
            }
          }
        })
      }

      this.editableTabsValue = activeName
      this.form.contentList = tabs.filter(tab => tab.id !== targetName)
    },
    getInfo (id) {
      let that = this
      getProductInfo(id)
        .then(res => {
          if (res.contentList.length > 0) {
            that.editableTabsValue = res.contentList[0].id
          }
          that.form = res
        })
    },
    confirm () {
      if (this.id) {
        this.getModify('form')
      } else {
        this.getCreate('form')
      }
    },
    getProductCateOption () {
      let that = this
      getProductCateOption().then(res => {
        that.productCateOption = res
      })
    },
    onEditorBlur (quill) {
      console.log('editor blur!', this.form.content, quill)
    },
    onEditorFocus (quill) {
      console.log('editor focus!', this.form.content, quill)
    },
    onEditorReady (quill) {
      console.log('editor ready!', quill)
    },
    // 新增
    getCreate (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        if (valid) {
          that.form.contentList.forEach((item, index) => {
            if (item.id < 100000) {
              item.id = null
            }
          })
          addProduct(that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '新增成功',
              type: 'success',
              duration: 2000
            })
            that.$router.back()
            // that.$router.push("/demo/helper/keyword");
          })
        }
      })
    },

    // 编辑
    getModify (forms) {
      let that = this
      that.$refs[forms].validate(valid => {
        if (valid) {
          that.form.contentList.forEach((item, index) => {
            if (item.id < 100000) {
              item.id = null
            }
          })
          updateProduct(that.id, that.form).then(res => {
            that.$notify({
              title: '成功',
              message: '修改成功',
              type: 'success',
              duration: 2000
            })
            that.$router.back()
            // that.$router.push("/demo/helper/keyword");
          })
        }
      })
    }

  },
  mounted () {
    let that = this
    that.id = that.$route.query.id

    if (that.id != null) {
      that.getInfo(that.id)
    }
    that.getProductCateOption()
    that.getThemeTpl()
    initTitle()
  }
}

</script>
<style scoped>
/deep/.el-input-number {
  margin-right: 12px;
}
.footer {
  text-align: center;
  margin-top: 20px;
}
.spec-item {
  position: relative;
  margin-top: 20px;
  background-color: #f5f7fa;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ebeef5;
}

.spec-item-bottom-right {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  padding: 2px;
  background-color: rgba(189, 189, 189, 0.55);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 999;
}
</style>
